import { Reveal, MaskedLine } from "./Reveal";

export const PageHero = ({ eyebrow, title, subtitle, image, children }) => (
  <section className="relative overflow-hidden bg-navy">
    <div className="absolute inset-0">
      <img src={image} alt="" className="h-full w-full object-cover opacity-25" loading="eager" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/40" />
    </div>
    <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-28 lg:px-8 lg:py-32">
      <Reveal y={16}>
        <p className="eyebrow !text-teal-300">{eyebrow}</p>
      </Reveal>
      <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
        <MaskedLine delay={0.1}>{title}</MaskedLine>
      </h1>
      {subtitle && (
        <Reveal delay={0.35}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">{subtitle}</p>
        </Reveal>
      )}
      {children && <Reveal delay={0.5}><div className="mt-8 flex flex-wrap gap-3">{children}</div></Reveal>}
    </div>
  </section>
);
